import { Paper, SxProps, Theme } from "@mui/material";
import { PropsWithChildren } from 'react';

export type StepMenuContainerProps = {
    sx?: SxProps<Theme>    
};

export default function StepMenuContainer({
    sx,
    children
}: PropsWithChildren<StepMenuContainerProps>) {
    return (
        <Paper
            sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflow: "hidden",
                ...sx
            }}
            elevation={0}
        >
            {children}
        </Paper>
    );
}